<template>
  <div class="app-container">
    <div class="navbar-group">
      <div class="navbar-group">
        <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>

        <el-button type="primary" @click.native="save" :disabled="!canWrite">保存</el-button>
        <!--  @click.native="orderReview" -->
        <el-button
          type="primary"
          @click.native="orderReview"
          :disabled="!isSave || !canReview"
          >{{ ReviewName }}</el-button
        >
        <el-button type="primary" @click.native="orderDel" :disabled="!isSave || !canWrite"
          >删除</el-button
        >
      </div>

      <!-- <template v-if="data.Status < 2 && mode == 'details'">
        <el-button :loading="isLoading" type="danger" @click="save('examine')"
          >审 核</el-button
        >
      </template>
      <template v-if="data.Status == 2 && mode == 'review'">
        <el-button :loading="isLoading" type="danger" @click="save('cancel')"
          >弃 审</el-button
        >
      </template>
      <template v-if="mode != 'review' && mode != 'details'">
        <el-button type="primary" @click="save('save')">保 存</el-button>
      </template> -->
      <!-- <el-button @click="close">关 闭</el-button>     -->
    </div>
    <el-form
      ref="dialog"
      :data="data"
      label-width="100px"
      :model="data"
      :rules="rules"
      :inline="true"
    >
      <el-row class="border">
        <el-row>
          <el-form-item label="收入单编号" prop="DocNo">
            <span v-if="Mode == 0 || isDetails" class="not-edit">{{
              data.DocNo
            }}</span>
            <el-input
              v-else
              v-model="data.DocNo"
              style="width: 193px"
            ></el-input>
          </el-form-item>
          <el-form-item label="单据日期" prop="DocDate">
            <span class="not-edit" v-if="isDetails">{{
              $commonJs.toDateString(data.DocDate)
            }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 193px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="往来单位"
            prop="TradeUnitId"
            :rules="data.NeedTradeUnit ? tu : null"
          >
            <span class="not-edit" v-if="isDetails">{{
              data.TradeUnitName
            }}</span>
            <el-select 
              v-else 
              v-model="data.TradeUnitId"
              filterable style="width: 180px">
              <div
                style="
                  max-height: 274px;
                  overflow: scroll;
                  margin-bottom: -17px;
                  margin-right: -17px;
                "
              >
                <el-option
                  v-for="item in tradeUnitList"
                  :key="item.TradeUnitId"
                  :value="item.TradeUnitId"
                  :label="item.FullName"
                  @click.native="setTradeunit(item)"
                ></el-option>
              </div>

             
            </el-select>
            <!-- <select-input
              v-else
              placeholder="请选择单位"
              :label="data.TradeUnitName"
              v-model="data.TradeUnitId"
              @click="openTradeunit"
            /> -->
          </el-form-item>
          <el-form-item label="票据类型" prop="InvoiceTypeId">
            <span class="not-edit" v-if="isDetails">{{
              data.InvoiceTypeName
            }}</span>
            <invoice-select
              v-else
              v-model="data.InvoiceTypeId"
              @change="invoiceChange($event,data)"
              :clearable="false"
            />
          </el-form-item>
          <!-- <el-form-item label="业务类型" prop="BusinessTypeId">
            <span class="not-edit" v-if="isDetails">{{
              data.BusinessType
            }}</span>
            <business-select
              v-else
              v-model="data.BusinessTypeId"
              :params="{ Kind: '应收', SourceType: '收入单' }"
              @change="onChange"
            />
          </el-form-item> -->
          <el-form-item label="经办人" prop="ClerkId">
            <span class="not-edit" v-if="isDetails">{{ data.ClerkName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.ClerkName"
              v-model="data.ClerkId"
              @click="openEmp"
            />
          </el-form-item>
          
        <el-form-item label="收款到期日:" prop="LastDate">
          <span class="not-edit" v-if="isDetails">{{
            $commonJs.toDateString(data.LastDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.LastDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 193px"
          >
          </el-date-picker>
        </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注:" prop="Remark">
            <span class="not-edit" v-if="isDetails">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-row>
      </el-row>

      <template v-if="data.InvoiceTypeId != null">
        <edit-list2
          v-if="data.InvoiceTypeName == '收据'"
          ref="editList"
          :IsDetail="isDetails"
          :invoiceStatus="invoiceStatus"
        />
        <edit-list1 v-else ref="editList"           :invoiceStatus="invoiceStatus"
 :IsDetail="isDetails" />
      </template>

      <div class="row-tb-head" style="margin-top: 10px">
        <span>收款信息</span>
        <div style="float: right" v-if="!isDetails">
          <el-button type="primary" icon="el-icon-plus" @click="addReceipt"
            >添加</el-button
          >
        </div>
      </div>
      <el-table
        border
        class="table-line tb-c-head"
        :data="data.RpIncomeDocReceiptDtos"
      >
        <el-table-column
          prop="SettleName"
          label="结算方式"
          min-width="110"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.SettleName }}</span>
            <el-select
              v-else
              v-model="row.SettleId"
              @change="setSettle(row)"
              placeholder="请选择结算方式"
            >
              <el-option
                v-for="(i, key) in Settles"
                :key="key"
                :label="i.SettleName"
                :value="i.SettleId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="AccountName" label="收款账号" align="center">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.AccountName }}</span>
            <select-input
              v-else
              placeholder="请选择账号"
              :label="row.AccountName"
              v-model="row.AccountId"
              @click="openAccount(row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptAmount" label="收款金额" align="center" v-if="canPrice">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ $commonJs.toThousands(row.ReceiptAmount) }}</span>
            <el-input
              v-else
              v-model="row.ReceiptAmount"
              type="number"
              @input="onInput(row)"
              placeholder="请输入收款金额"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="95"
          fixed="right"
          v-if="!isDetails"
        >
          <template slot-scope="{ row, $index }">
            <!-- <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link> -->
            <el-link @click="delReceipt(row, $index)" :underline="false"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <!-- <common-dialog ref="dialog" width="1100px" line-form unit="收入单" edit-title id-key="DocId" :data="data"
      :get-data-func="api.info" form-label-width="95px" @create-opened="onCreateOpened" @edit-opened="onEditOpened"
      @opened="onOpened" :form-rules="rules" @closed="onClosed">
      <template slot="form">
      
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        
        <el-button type="primary" :loading="isLoading" @click="save('save')">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>


    </common-dialog> -->
    <!-- 后面补充 -->
    <account-dialog ref="accountDialog" in-dialog selectable @select="setAccount" />
    <tradeUnit-dialog
      ref="tradeUnitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountDialog from "@/components/basedata/finance/account/listDialog";
import businessSelect from "@/components/basedata/basedoc/business/select";
import invoiceSelect from "@/components/basedata/finance/invoice/select";
import tradeUnitDialog from "@/components/basedata/business/come/listDialog";
import empDialog from "@/components/personnel/result/record/listDialog";
import editList1 from "@/components/finance/dealings/income/editList1";
import editList2 from "@/components/finance/dealings/income/editList2";

export default {
  name: "editIncome",
  mixins: [editDialogMixin],
  components: {
    commonDialog,
     accountDialog,
    businessSelect,
    invoiceSelect,
    tradeUnitDialog,
    empDialog,
    editList1,
    editList2,
  },
  data() {
    return {
      api: require("@/api/rp/incomeDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      settle_api: require("@/api/ba/settle").default,
      income_api: require("@/api/ba/income").default,
      cost_api: require("@/api/ba/cost").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      getInvoiceApi: require("@/api/ba/invoiceType").default,
      invoiceList:[],
      mode: null,
      invoiceStatus:true,
      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: 0, //业务类型
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        NeedTradeUnit: true,
        LastDate: null, //收款到期日
        RpIncomeDocDtsDtos: [],
        RpIncomeDocReceiptDtos: [],
      },
      Mode: 0,
      DelRpIncomeDocReceiptDtos: [],
      current: null,
      Settles: [], //结算方式列表
      Income: [], //收入
      tradeUnitList: [],
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
        // BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        InvoiceTypeId: [{ required: true, message: "请选择票据类型" }],
        LastDate: [{ required: true, message: "收款到期日不能为空" }],
      },
      tu: [{ required: true, message: "请选择单位" }],
    };
  },
  computed: {
    isDetails() {
      return Boolean(this.data.Status === 2);
    },
    isSave() {
      return Boolean(this.data.DocId > 0);
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/income");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/dealings/income");
    },
    canReview() {
      return this.$permission.canReview("/finance/dealings/income");
    },
  },
  beforeMount() {
    this.onOpened();
    this.getCurd();
  },
  mounted(){
    this.init()
  },
  methods: {
    init(){
      this.getInvoiceApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.invoiceList = res.Data.map((item) => {
            return {
              key: item.InvoiceTypeId,
              label: item.InvoiceTypeName,
              value: item.InvoiceTypeId,
            };
          });
        }
      });
      this.tradeUnitApi.list({ TradeUnitTypes: [0,2] ,Status:1}).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
    },
    getCurd() {
      const mode = this.$route.params.mode;
      const row = this.$route.params.data ?? {};
      switch (mode) {
        case "create":
          this.onCreateOpened();
          break;
        case "edit":
          this.onEditOpened(row.DocId);
          break;
        case "editById":
          this.onEditOpened(row.DocId);
          break;
        case "details":
          this.onDetailsOpened(row);
          break;
        case "review":
          this.onReviewed(row);
          break;
        default:
          this.onCreateOpened();
          break;
      }
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("收入单", dateTime).then((res) => {
       // console.log("serialType", res);
        if (res.Code == 0) {
          this.mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取收入单编号失败");
        }
      });
    },
    onCreateOpened() {
      var user = this.$store.state.user;
      console.log("user", JSON.parse(JSON.stringify(user)));
      this.data.DocDate = this.$commonJs.getToday();
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.getPreviewNo();
      this.init();
      // this.addReceipt();
    },
    onEditOpened(data, type = 0) {
      this.api
        .info(data)
        .then((res) => {
          if (res.Code === 0) {
            res.Data.RpIncomeDocDtsDtos = res.Data.RpIncomeDocDtsDtos.map(
              (x) => {
                return { ...x, T: 3 };
              }
            );
            res.Data.RpIncomeDocReceiptDtos =
              res.Data.RpIncomeDocReceiptDtos.map((x) => {
                return { ...x, T: 3 };
              });
            this.data = res.Data;
            console.log("this.data", this.Data);
             if (type === 1) {
              this.Review();
            }
          }
        })
        .then(() => {
          this.$refs.editList.setData(this.data.RpIncomeDocDtsDtos);
          this.$refs.editList.setIncome(this.Income);
          // this.$refs.editList.setData(this.data.RpCostDocDts);
          // this.$refs.editList.setCost(this.Cost);
        });
      // console.log("编辑", data);
      // this.data.RpIncomeDocDtsDtos = this.data.RpIncomeDocDtsDtos.map((x) => {
      //   return { ...x, T: null };
      // });
      // this.data.RpIncomeDocReceiptDtos = this.data.RpIncomeDocReceiptDtos.map(
      //   (x) => {
      //     return { ...x, T: null };
      //   }
      // );
      // this.$nextTick(() => {
      //   this.$refs.editList.setData(this.data.RpIncomeDocDtsDtos);
      //   this.$refs.editList.setIncome(this.Income);
      // });
    },
    onDetailsOpened(data) {
      this.api
        .info(data.DocId)
        .then((res) => {
          if (res.Code === 0) {
            res.Data.RpIncomeDocDtsDtos = res.Data.RpIncomeDocDtsDtos.map(
              (x) => {
                return { ...x, T: 3 };
              }
            );
            res.Data.RpIncomeDocReceiptDtos =
              res.Data.RpIncomeDocReceiptDtos.map((x) => {
                return { ...x, T: 3 };
              });
            this.data = res.Data;
            console.log("this.data", this.Data);
          }
        })
        .then(() => {
          this.$refs.editList.setData(this.data.RpIncomeDocDtsDtos);
          this.$refs.editList.setIncome(this.Income);
          // this.$refs.editList.setData(this.data.RpCostDocDts);
          // this.$refs.editList.setCost(this.Cost);
        });
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.onOpened();
      this.onCreateOpened();
      // this.add();

      setTimeout(() => {
        this.$refs.dialog.clearValidate();
      }, 30);
    },
    onDetailed() {
      this.isDetails = true;
    },
    onReviewed() {
      this.isDetails = false;
    },
    onOpened() {
      this.settle_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Settles = res.Data;
      });
      this.income_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Income = res.Data;
      });
    },
    onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    invoiceChange(e,data) {
      console.log(e,'e')
      let index =this.invoiceList.findIndex(el=>e==el.key)
     this.data.InvoiceTypeName=this.invoiceList[index].label
     if(this.invoiceList[index].label=='收据'){this.invoiceStatus=false}else{this.invoiceStatus=true} 
      this.$nextTick(() => {
        this.$refs.editList.setIncome(this.Income, data.DefTaxRate);
      });
    },
    addReceipt() {
      var item = {
        DocReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: "",
        AccountId: null,
        AccountName: "",
        ReceiptAmount: null, //收款金额
        T: 0,
      };
      this.data.RpIncomeDocReceiptDtos.push(item);
    },
    setSettle(row) {
      console.log("setSettle", row);
      var settle = this.Settles.find((x) => x.SettleId == row.SettleId);
      if(row.T !== 0){
        row.T = 1
      }
      row.AccountId = settle.AccountId;
      row.AccountName = settle.AccountName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openAccount(row) {
      this.current = row;
      this.$refs.accountDialog.open().then((that) => {
        that.getData();
      });
    },
    setAccount(data) {
      if(this.current.T !== 0){
        this.current.T = 1;
      }
      this.current.AccountId = data.AccountId;
      this.current.AccountName = data.AccountName;
    },
    openTradeunit() {
      this.$refs.tradeUnitDialog.open().then((that) => {
        that.getTree();
      });
    },
    setTradeunit(data) {
      // this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      // row.ReceiptAmount = this.$commonJs.obj.toNumber(row.ReceiptAmount);
      var items = this.data.RpIncomeDocReceiptDtos.filter(
        (x) => !!x.ReceiptAmount
      ).map((x) => parseFloat(x.ReceiptAmount));
      var amount = null;
      if (items.length > 0) {
        amount = items.reduce((a, b) => {
          return a + b;
        });
      }
      this.data.ReceiptAmount = amount;
    },
    delReceipt(row, index) {
      if (row.T != 0) this.DelRpIncomeDocReceiptDtos.push({ ...row, T: 2 });
      this.data.RpIncomeDocReceiptDtos.splice(index, 1);
    },
    Review(){
      this.api.examine(this.data.DocId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          const id = this.data.DocId == 0 ? res.Data : this.data.DocId;
            this.onEditOpened(id, type);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() { 
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }

      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "cancel" : "examine";
          if(data === 'examine'){
            this.save(1);
          }else if(data === 'cancel'){
            this.api[data](this.data.DocId).then((res) => {
              if (res.Code === 0 && data == "examine") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "cancel") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                const id = this.data.DocId == 0 ? res.Data : this.data.DocId;
                this.onEditOpened(id, type);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.DocId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    save(type = 0) {
      this.$refs.dialog.validate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        console.log("this.$refs.editList.Data",this.$refs.editList.Data);
        data.RpIncomeDocDtsDtos = this.$refs.editList.Data.filter(
          (x) => x.IncomeId != 0&&x.T!=null
        );
        console.log("data.RpIncomeDocDtsDtos",data.RpIncomeDocDtsDtos);
        if (data.RpIncomeDocDtsDtos.length == 0) {
          this.$message.warning("收入信息不能为空");
          return;
        }
        // if (data.RpIncomeDocReceiptDtos.length == 0) {
        //   this.$message.warning("收款信息不能为空");
        //   return;
        // }

        var incomeId = data.RpIncomeDocDtsDtos.every((x) => !!x.IncomeId);
        if (!incomeId) {
          this.$message.warning("收入信息 - 收入名称不能为空");
          return;
        }
        var amount = data.RpIncomeDocDtsDtos.every((x) => !!x.Amount);
        if (!amount) {
          this.$message.warning("收入信息 - 金额不能为空");
          return;
        }
        if (data.InvoiceTypeName != "收据") {
          var taxRate = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxRate);
          if (!taxRate) {
            this.$message.warning("收入信息 - 税率不能为空");
            return;
          }
          // var taxAmount = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxAmount);
          // if (!taxAmount) {
          //   this.$message.warning("收入信息 - 税额不能为空");
          //   return;
          // }
          // var incTaxAmount = data.RpIncomeDocDtsDtos.every(
          //   (x) => !!x.IncTaxAmount
          // );
          // if (!incTaxAmount) {
          //   this.$message.warning("收入信息 - 含税金额不能为空");
          //   return;
          // }
        }
        else
        {
          data.RpIncomeDocDtsDtos.forEach((x) => {
            if (x.TaxAmount == null) x.TaxAmount = 0;
            if (x.IncTaxAmount == null) x.IncTaxAmount = 0;
          });
        }
        var DelRpIncomeDocDtsDtos = this.$refs.editList.DelData;
        // data.RpIncomeDocDtsDtos = data.RpIncomeDocDtsDtos.filter(
        //   (x) => x.T != null
        // );
        data.RpIncomeDocDtsDtos.forEach((x) => (x.DocId = this.data.DocId));
        DelRpIncomeDocDtsDtos.forEach((x) => {
          if(x.IncomeId!=0){            
          data.RpIncomeDocDtsDtos.push(x);
          }
        });
        if(this.data.RpIncomeDocReceiptDtos.length>0){
          
        var settleId = this.data.RpIncomeDocReceiptDtos.every((x) => !!x.SettleId);
        if (!settleId) {
          this.$message.warning("收款信息 - 结算方式不能为空");
          return;
        }
        var accountId = this.data.RpIncomeDocReceiptDtos.every((x) => !!x.AccountId);
        if (!accountId) {
          this.$message.warning("收款信息 - 账号不能为空");
          return;
        }
        var receiptAmount = this.data.RpIncomeDocReceiptDtos.every(
          (x) => !!x.ReceiptAmount
        );
        if (!receiptAmount) {
          this.$message.warning("收款信息 - 收款金额不能为空");
          return;
        }
        data.RpIncomeDocReceiptDtos = JSON.parse(JSON.stringify(this.data.RpIncomeDocReceiptDtos))
        // data.RpIncomeDocReceiptDtos = data.RpIncomeDocReceiptDtos.filter(
        //   (x) => x.SettleId != null
        // );
        this.DelRpIncomeDocReceiptDtos.forEach((x) => {
          if(x.SettleId!=null){
            data.RpIncomeDocReceiptDtos.push(x);
          }
        });

        if( data.RpIncomeDocReceiptDtos.length>0){
          console.log('data.RpIncomeDocDtsDtos', data.RpIncomeDocDtsDtos)
          var docAmount=data.RpIncomeDocDtsDtos.filter(item => item.T !== 2).map((item) => {
            return parseFloat(item.Amount);
          })
          .reduce((total, number) => {
            return total + number;
          });

          console.log('docAmount', docAmount)

          console.log('data.RpIncomeDocReceiptDtos', data.RpIncomeDocReceiptDtos)
         var incomAmount = data.RpIncomeDocReceiptDtos.filter(item => item.T !== 2).map((item) => {
            return parseFloat(item.ReceiptAmount);
          })
          .reduce((total, number) => {
            return total + number;
          });
          console.log('incomAmount', incomAmount)
          if(docAmount!=incomAmount){
            
          this.$message.warning("收入金额和收款金额不一致");
          return;
          }

          data.RpIncomeDocDtsDtos = data.RpIncomeDocDtsDtos.filter(item => {
            return item.T != null
          })

          data.RpIncomeDocReceiptDtos = data.RpIncomeDocReceiptDtos.filter(item => {
            return item.T != null
          })
        }

      }

        console.log("保存", this.$commonJs.toJson(this.data));

        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if (type !== 1) {
              this.$message.success(res.Msg);
            }
            const id = this.data.DocId == 0 ? res.Data : this.data.DocId;
            this.onEditOpened(id, type);
            this.onClosed();
          } else {
            this.$message.error(res.Msg);
          }
          // if (res.Code == 0) {
          //   if(type !== 1){
          //     this.$message.success(res.Msg);
          //   }
          //   const id =
          //     this.data.DocId == 0 ? res.Data : this.data.DocId;
          //   this.api.info(id).then((result) => {
          //     this.data = result.Data;
          //     if(type === 1){
          //       this.Review()
          //     }
          //   });
          //   this.onClosed(true);
          // } else {
          //   this.$message.error(res.Msg);
          // }
        });
      });
    },
    close() {},
    onClosed() {
      this.DelRpIncomeDocReceiptDtos = [];
      this.data.RpIncomeDocReceiptDtos = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}
.detail-span {
  padding-left: 0;
  display: inline-block;
}
.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}
.dropdown-item {
  padding: 5px 10px;
}
</style>
